module.exports = __webpack_public_path__ + "img/140.34f00ff6.jpg";